import {api} from './api';

export const postsApi = api.injectEndpoints({
    endpoints: build => ({
        getVacancy: build.query<ListResponse<ItemVacancy>, void | QueryArg>({
            query: ({offset, limit, url, branch}: QueryArg) => {
                if (url) {
                    return url
                }
                return `/about/vacancy?offset=${offset}&limit=${limit}&branch=${branch}`
            },
            providesTags: data =>
                data
                    ? [
                        ...data.results.map(({id}) => ({
                            type: 'Faq' as const,
                            id,
                        })),
                        {type: 'Vacancy', id: 'VACANCY-LIST'},
                    ]
                    : [...[], {type: 'Faq', id: 'VACANCY-LIST'}],
        }),
    }),
});

export const {useGetVacancyQuery} = postsApi;

export const {
    endpoints: {getVacancy},
} = postsApi;
